/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/indexManage',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '自营-首页管理',
      icon: 'component',
    },
    children: [
      {
        path: '/indexManage/hotsearchConfig',
        component: () => import('@/myviews/shoppMall/indexManage/hotsearchConfig/hotsearchConfigList.vue'),
        name: 'hotsearchConfig',
        meta: {
          alwaysShow: false,
          title: '热搜词管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      }, 
      {
        path: '/indexManage/adManage',
        component: () => import('@/myviews/shoppMall/indexManage/adManage/adManageList.vue'),
        alwaysShow: false,
        name: 'adManage',
        meta: {
          title: '广告位管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/indexManage/columnManage',
        component: () => import('@/myviews/shoppMall/indexManage/columnManage/columnManageList.vue'),
        alwaysShow: false,
        name: 'columnManage',
        meta: {
          title: '栏目管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/productManage/quicklyFindManage',
        component: () => import('@/myviews/shoppMall/productManage/quicklyFindManage/quicklyFindManageList.vue'),
        alwaysShow: false,
        name: 'quicklyFindManage',
        meta: {
          title: '快速找药管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
      {
        path: '/indexManage/floorManage',
        component: () => import('@/myviews/shoppMall/indexManage/floorManage/floorManageList.vue'),
        alwaysShow: false,
        name: 'floorManage',
        meta: {
          title: '楼层管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      // {
      //   path: '/indexManage/themeManage',
      //   component: () => import('@/myviews/shoppMall/indexManage/themeManage/themeManageList.vue'),
      //   alwaysShow: false,
      //   name: 'themeManage',
      //   meta: {
      //     title: '主题设置',
      //     roles: ['add', "modify", "viewpage"],
      //     have: [],
      //   },
      // },
      {
        path: '/indexManage/themeManageSet',
        component: () => import('@/myviews/shoppMall/indexManage/themeManageSet/themeManageSetList.vue'),
        alwaysShow: false,
        name: 'themeManageSet',
        meta: {
          title: '新主题设置',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/indexManage/themeManageSetAdd',
        component: () => import('@/myviews/shoppMall/indexManage/themeManageSet/components/themeManageSetAdd.vue'),
        alwaysShow: false,
        hidden: true,
        name: 'themeManageSetAdd',
        meta: {
          title: '新主题设置新增',
          roles: ['add', "modify", "viewpage"],
          have: [],
        }
      },
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/shoppMall/indexManage.js